export const GET_USER_GEO_INFO_REQUEST = "GET_USER_GEO_INFO_REQUEST";
export const GET_USER_GEO_INFO_SUCCESS = "GET_USER_GEO_INFO_SUCCESS";
export const GET_USER_GEO_INFO_FAILURE = "GET_USER_GEO_INFO_FAILURE";

export const GET_ALL_INDUSTRIES_REQUEST = "GET_ALL_INDUSTRIES_REQUEST";
export const GET_ALL_INDUSTRIES_SUCCESS = "GET_ALL_INDUSTRIES_SUCCESS";
export const GET_ALL_INDUSTRIES_FAILURE = "GET_ALL_INDUSTRIES_FAILURE";

export const GET_ALL_JOB_ROLES_REQUEST = "GET_ALL_JOB_ROLES_REQUEST";
export const GET_ALL_JOB_ROLES_SUCCESS = "GET_ALL_JOB_ROLES_SUCCESS";
export const GET_ALL_JOB_ROLES_FAILURE = "GET_ALL_JOB_ROLES_FAILURE";

export const GET_ALL_JOB_TITLES_REQUEST = "GET_ALL_JOB_TITLES_REQUEST";
export const GET_ALL_JOB_TITLES_SUCCESS = "GET_ALL_JOB_TITLES_SUCCESS";
export const GET_ALL_JOB_TITLES_FAILURE = "GET_ALL_JOB_TITLES_FAILURE";

export const GET_ALL_COUNTRIES_REQUEST = "GET_ALL_COUNTRIES_REQUEST";
export const GET_ALL_COUNTRIES_SUCCESS = "GET_ALL_COUNTRIES_SUCCESS";
export const GET_ALL_COUNTRIES_FAILURE = "GET_ALL_COUNTRIES_FAILURE";

export const GET_ALL_LANGUAGES_REQUEST = "GET_ALL_LANGUAGES_REQUEST";
export const GET_ALL_LANGUAGES_SUCCESS = "GET_ALL_LANGUAGES_SUCCESS";
export const GET_ALL_LANGUAGES_FAILURE = "GET_ALL_LANGUAGES_FAILURE";

export const UNSUBSCRIBE_REQUEST = "UNSUBSCRIBE_REQUEST";
export const UNSUBSCRIBE_SUCCESS = "UNSUBSCRIBE_SUCCESS";
export const UNSUBSCRIBE_FAILURE = "UNSUBSCRIBE_FAILURE";

export const SHARE_FEEDBACK_REQUEST = "SHARE_FEEDBACK_REQUEST";
export const SHARE_FEEDBACK_SUCCESS = "SHARE_FEEDBACK_SUCCESS";
export const SHARE_FEEDBACK_FAILURE = "SHARE_FEEDBACK_FAILURE";

export const GET_PIN_REQUEST = "GET_PIN_REQUEST";
export const GET_PIN_SUCCESS = "GET_PIN_SUCCESS";
export const GET_PIN_FAILURE = "GET_PIN_FAILURE";

export const VERIFY_PIN_REQUEST = "VERIFY_PIN_REQUEST";
export const VERIFY_PIN_SUCCESS = "VERIFY_PIN_SUCCESS";
export const VERIFY_PIN_FAILURE = "VERIFY_PIN_FAILURE";

export const GET_PREFERENCES_REQUEST = "GET_PREFERENCES_REQUEST";
export const GET_PREFERENCES_SUCCESS = "GET_PREFERENCES_SUCCESS";
export const GET_PREFERENCES_FAILURE = "GET_PREFERENCES_FAILURE";

export const SET_PREFERENCES_REQUEST = "SET_PREFERENCES_REQUEST";
export const SET_PREFERENCES_SUCCESS = "SET_PREFERENCES_SUCCESS";
export const SET_PREFERENCES_FAILURE = "SET_PREFERENCES_FAILURE";

export const EMAIL_SIGNUP_REQUEST = "EMAIL_SIGNUP_REQUEST";
export const EMAIL_SIGNUP_SUCCESS = "EMAIL_SIGNUP_SUCCESS";
export const EMAIL_SIGNUP_FAILURE = "EMAIL_SIGNUP_FAILURE";

export const GET_TOPICS_REQUEST = "GET_TOPICS_REQUEST";
export const GET_TOPICS_SUCCESS = "GET_TOPICS_SUCCESS";
export const GET_TOPICS_FAILURE = "GET_TOPICS_FAILURE";

export const GET_PROFILE_REQUEST = "GET_PROFILE_REQUEST";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILURE = "GET_PROFILE_FAILURE";

export const GET_EXTENDED_USER_PROFILE_REQUEST = "GET_EXTENDED_USER_PROFILE_REQUEST";
export const GET_EXTENDED_USER_PROFILE_SUCCESS = "GET_EXTENDED_USER_PROFILE_SUCCESS";
export const GET_EXTENDED_USER_PROFILE_FAILURE = "GET_EXTENDED_USER_PROFILE_FAILURE";

export const UPDATE_EXTENDED_USER_PROFILE_REQUEST = "UPDATE_EXTENDED_USER_PROFILE_REQUEST";
export const UPDATE_EXTENDED_USER_PROFILE_SUCCESS = "UPDATE_EXTENDED_USER_PROFILE_SUCCESS";
export const UPDATE_EXTENDED_USER_PROFILE_FAILURE = "UPDATE_EXTENDED_USER_PROFILE_FAILURE";

export const SET_BAR_MESSAGE = "SET_BAR_MESSAGE";
export const REMOVE_BAR_MESSAGE = "REMOVE_BAR_MESSAGE";

export const SET_LOADING = "SET_LOADING";

export const SET_REDIRECT_TARGET = "SET_REDIRECT_TARGET";

export const SET_LOADING_GLOBAL = "SET_LOADING_GLOBAL";

export const SET_LOCALE_SUCCESS = "SET_LOCALE_SUCCESS";

export const AUTH_LOGOUT = "AUTH_LOGOUT";
